import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'

import { types as AuthTypes } from 'store/Auth'

import Account from './Account'
import Address from './Address'
import App from './App'
import Applicant from './Applicant'
import Auth from './Auth'
import BinderPayment from './BinderPayment'
import Bundles from './Bundles'
import Care from './Care'
import Doctor from './Doctor'
import Expense from './Expense'
import Fills from './Fills'
import Guarantees from './Guarantees'
import Group from './Group'
import Flow from './Flow'
import HealthQuestions from './HealthQuestions'
import Location from './Location'
import Member from './Member'
import MemberCommunication from './MemberCommunication'
import Notification from './Notification'
import Plan from './Plan'
import PaymentMethod from './PaymentMethod'
import PointSolutions from './PointSolutions'
import Policy from './Policy'
import SearchFilters from './SearchFilters'
import SmartLayer from './SmartLayer'
import Subscription from './Subscription'
import Suggestions from './Suggestions'
import TrustPilot from './TrustPilot'
import UncoveredApplicant from './UncoveredApplicant'
import Checks from './Checks'
import Contentful from './Contentful'
import Vimeo from './Vimeo'

// UI specific stores
import CareUI from './ui/Care'
import { initialState } from './Auth'

const appReducers = {
  Account,
  Address,
  App,
  Applicant,
  Auth,
  BinderPayment,
  Bundles,
  Care,
  Checks,
  Contentful,
  Doctor,
  Expense,
  Fills,
  Guarantees,
  Group,
  Flow,
  HealthQuestions,
  Location,
  Member,
  MemberCommunication,
  Notification,
  Plan,
  PaymentMethod,
  PointSolutions,
  Policy,
  SearchFilters,
  SmartLayer,
  Subscription,
  Suggestions,
  TrustPilot,
  UncoveredApplicant,
  Vimeo,

  // UI specific stores
  CareUI,
}

const rootReducers = combineReducers({
  ...appReducers,
  form: formReducer,
})

export default (state = {}, action) => {
  if (
    action.type === AuthTypes.LOGOUT_SUCCESS ||
    action.type === AuthTypes.FORCE_LOGOUT
  ) {
    const nextState = {
      App: state.App,
      Auth: {
        ...initialState,
        isAuthAttempted: state.Auth.isAuthAttempted,
      },
      Notification: state.Notification,
      Location: {
        ipLocation: state.Location.ipLocation,
      },
    }
    return rootReducers(nextState, action)
  } else {
    return rootReducers(state, action)
  }
}
